// Roles allowed to see monetary amounts (order cost, balance, invoice totals, payments)
export const FINANCE_ROLES = [
  "super_admin",
  "admin",
  "sales_executive",
  "accountant",
  "customer",
];

export const canSeeAmount = (user) =>
  !!user && FINANCE_ROLES.includes(user.role);

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_print-orders-hub-3/artifacts/unsa466y_Brothers%20Logo.png";
